import { createComponent } from '@front/utils/alpine';
import { throttle } from 'lodash-es';
var EQUERY_TYPES;
(function (EQUERY_TYPES) {
    EQUERY_TYPES[EQUERY_TYPES["FACETS"] = 0] = "FACETS";
    EQUERY_TYPES[EQUERY_TYPES["NEXT_PAGE"] = 1] = "NEXT_PAGE";
})(EQUERY_TYPES || (EQUERY_TYPES = {}));
function toggleBodyOverflow(force) {
    document.body.classList.toggle('overflow-y-hidden', force);
}
const action = document.querySelector('meta[name="filter-action-url"]');
const Price = createComponent((opts) => ({
    minprice: opts.minprice,
    maxprice: opts.maxprice,
    min: opts.min,
    max: opts.max,
    minthumb: 0,
    maxthumb: 0,
    mintrigger() {
        if (this.minprice < this.min) {
            this.minprice = this.min;
        }
        this.minprice = Math.min(this.minprice, this.maxprice - 1);
        this.minthumb =
            ((this.minprice - this.min) / (this.max - this.min)) * 100;
        const input = this.$refs.input;
        const values = input.value.split('-');
        input.value = this.minprice + '-' + values[1];
    },
    maxtrigger() {
        if (this.maxprice > this.max) {
            this.maxprice = this.max;
        }
        this.maxprice = Math.max(this.maxprice, this.minprice + 1);
        this.maxthumb =
            100 -
                ((this.maxprice - this.min) / (this.max - this.min)) * 100;
        const input = this.$refs.input;
        const values = input.value.split('-');
        input.value = values[0] + '-' + this.maxprice;
    },
}));
const FacetsItems = createComponent(() => ({
    controller: new AbortController(),
    currentQuery: null,
    history: window.location.href,
    scroll: false,
    counter: 0,
    isReady: false,
    isLoading: false,
    facetsExpanded: false,
    facetsHasOverflow: false,
    facetsAdjusting: false,
    checkFacetsOverflow() {
        const el = this.$refs.facets_scroll;
        if (!el)
            return;
        const button = this.$refs.facets_toggle;
        const items = el.querySelectorAll('.js-facet-wrapper');
        items.forEach((item) => {
            item.style.removeProperty('display');
        });
        if (button)
            button.style.display = 'none';
        this.facetsAdjusting = true;
        requestAnimationFrame(() => {
            this.facetsAdjusting = false;
        });
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        if (!isDesktop) {
            this.facetsHasOverflow = false;
            return;
        }
        if (this.facetsExpanded) {
            if (button)
                button.style.removeProperty('display');
            this.facetsHasOverflow = true;
            return;
        }
        const padRight = parseFloat(getComputedStyle(el).paddingRight) || 0;
        const containerRight = el.getBoundingClientRect().left + el.clientWidth - padRight;
        let overflow = false;
        items.forEach((item) => {
            if (item.getBoundingClientRect().right > containerRight + 1) {
                overflow = true;
            }
        });
        if (!overflow) {
            this.facetsHasOverflow = false;
            return;
        }
        this.facetsHasOverflow = true;
        if (button)
            button.style.removeProperty('display');
        const gap = parseFloat(getComputedStyle(el).columnGap) || 0;
        const reserved = button
            ? button.getBoundingClientRect().width + gap
            : 0;
        const limit = containerRight - reserved;
        let hide = false;
        items.forEach((item) => {
            if (hide) {
                item.style.display = 'none';
                return;
            }
            if (item.getBoundingClientRect().right > limit + 1) {
                hide = true;
                item.style.display = 'none';
            }
        });
    },
    handleScrollEvent() {
        if (window.scrollY > this.$refs.grid.offsetTop + 100) {
            this.scroll = true;
        }
        else {
            this.scroll = false;
        }
    },
    checkFacets(ctx) {
        let count = 0;
        if (ctx) {
            count = 0;
            const parentNode = ctx.closest('.js-facet-wrapper');
            const stateDefault = parentNode.querySelector('.js-facet-state-default');
            const stateActive = parentNode.querySelector('.js-facet-state-active');
            const button = parentNode.querySelector('.js-facet-button');
            const facets = parentNode.querySelectorAll('.js-facet-input');
            const counter = parentNode.querySelector('.js-facet-counter');
            if (facets[0].name == 'prices') {
                if (facets[0].value !==
                    facets[0].dataset.min + '-' + facets[0].dataset.max) {
                    this.$refs.clean_button.classList.remove('hidden');
                    button.classList.add('active');
                    stateDefault?.classList.add('hidden');
                    stateActive?.classList.remove('hidden');
                    stateActive?.classList.add('flex');
                }
                else {
                    button.classList.remove('active');
                    stateDefault?.classList.remove('hidden');
                    stateActive?.classList.add('hidden');
                    stateActive?.classList.remove('flex');
                }
            }
            else {
                facets.forEach((facet) => {
                    if (facet.checked)
                        count++;
                });
                if (!count) {
                    button.classList.remove('active');
                    stateDefault?.classList.remove('hidden');
                    stateActive?.classList.add('hidden');
                    stateActive?.classList.remove('flex');
                }
                else {
                    this.$refs.clean_button.classList.remove('hidden');
                    button.classList.add('active');
                    stateDefault?.classList.add('hidden');
                    stateActive?.classList.remove('hidden');
                    stateActive?.classList.add('flex');
                    if (counter) {
                        counter.innerText = count.toString();
                    }
                }
            }
        }
        else {
            count = 0;
            const facets = document.querySelectorAll('.js-facet-input');
            facets.forEach((facet) => {
                if (facet.name == 'prices') {
                    const parentNode = facet.closest('.js-facet-wrapper');
                    const stateDefault = parentNode.querySelector('.js-facet-state-default');
                    const stateActive = parentNode.querySelector('.js-facet-state-active');
                    const button = parentNode.querySelector('.js-facet-button');
                    if (facet.value &&
                        facet.value !==
                            facet.dataset.min + '-' + facet.dataset.max) {
                        button.classList.add('active');
                        stateDefault?.classList.add('hidden');
                        stateActive?.classList.remove('hidden');
                        stateActive?.classList.add('flex');
                        this.$refs.clean_button.classList.remove('hidden');
                    }
                    else {
                        button.classList.remove('active');
                        stateDefault?.classList.remove('hidden');
                        stateActive?.classList.add('hidden');
                        stateActive?.classList.remove('flex');
                    }
                }
                else if (facet.type == 'checkbox' && facet.checked) {
                    count++;
                    this.$refs.clean_button.classList.remove('hidden');
                    const parentNode = facet.closest('.js-facet-wrapper');
                    const stateDefault = parentNode.querySelector('.js-facet-state-default');
                    const stateActive = parentNode.querySelector('.js-facet-state-active');
                    const button = parentNode.querySelector('.js-facet-button');
                    const counter = parentNode.querySelector('.js-facet-counter');
                    button.classList.add('active');
                    stateDefault?.classList.add('hidden');
                    stateActive?.classList.remove('hidden');
                    stateActive?.classList.add('flex');
                    if (counter) {
                        counter.innerText = count.toString();
                    }
                }
            });
        }
    },
    cleanFacets(element) {
        if (element) {
            const parentNode = element.closest('.js-facet-wrapper');
            const stateDefault = parentNode.querySelector('.js-facet-state-default');
            const stateActive = parentNode.querySelector('.js-facet-state-active');
            const button = parentNode.querySelector('.js-facet-button');
            const activeFacets = parentNode.querySelectorAll('.js-facet-input');
            activeFacets.forEach((facet) => {
                if (facet.checked)
                    facet.checked = false;
            });
            button.classList.remove('active');
            stateDefault?.classList.remove('hidden');
            stateActive?.classList.add('hidden');
            stateActive?.classList.remove('flex');
            this.updateFacets();
        }
        else {
            const activeFacets = document.querySelectorAll('.js-facet-input[type=checkbox]:checked');
            activeFacets.forEach((facet) => {
                const parentNode = facet.closest('.js-facet-wrapper');
                const stateDefault = parentNode.querySelector('.js-facet-state-default');
                const stateActive = parentNode.querySelector('.js-facet-state-active');
                const button = parentNode.querySelector('.js-facet-button');
                facet.checked = false;
                button.classList.remove('active');
                stateDefault?.classList.remove('hidden');
                stateActive?.classList.add('hidden');
                stateActive?.classList.remove('flex');
            });
            const sortFacets = document.querySelectorAll('.js-facet-input[type=radio]');
            sortFacets.forEach((facet) => {
                if (facet.checked && facet != sortFacets[0])
                    facet.checked = false;
            });
            sortFacets[0].checked = true;
            const priceFacets = document.querySelector('.js-facet-input[name="prices"]');
            if (priceFacets.value !==
                priceFacets.dataset.min + '-' + priceFacets.dataset.max) {
                priceFacets.value =
                    priceFacets.dataset.min + '-' + priceFacets.dataset.max;
                const parentNode = priceFacets.closest('.js-facet-wrapper');
                const stateDefault = parentNode.querySelector('.js-facet-state-default');
                const stateActive = parentNode.querySelector('.js-facet-state-active');
                const button = parentNode.querySelector('.js-facet-button');
                button.classList.remove('active');
                stateDefault?.classList.remove('hidden');
                stateActive?.classList.add('hidden');
                stateActive?.classList.remove('flex');
                window.dispatchEvent(new CustomEvent('price-clean'));
            }
            this.$refs.clean_button.classList.add('hidden');
            this.updateFacets();
        }
    },
    updateFacets() {
        this.isLoading = true;
        this.currentQuery = EQUERY_TYPES.FACETS;
        toggleBodyOverflow(this.isLoading);
        this.updateProductsList();
    },
    updateProductsList() {
        const inputs = document.querySelectorAll('.js-facet-input');
        const formData = new FormData();
        inputs.forEach((i) => {
            if (((i.type == 'checkbox' || i.type == 'radio') && !i.checked) ||
                !i.value ||
                (i.name === 'prices' &&
                    i.value === i.dataset.min + '-' + i.dataset.max)) {
                return;
            }
            formData.append(i.name, i.value);
        });
        const urlParams = new URLSearchParams(window.location.search);
        const isSearch = urlParams.get('query');
        if (isSearch) {
            formData.append('query', isSearch);
        }
        const url = new URL(action.content);
        url.search = new URLSearchParams(formData).toString();
        this.updateProductListDOM(url.toString());
    },
    updateProductListDOM(url) {
        if (this.$refs.rendered_products) {
            this.getProductList(url).then((data) => {
                const parser = new DOMParser();
                const productsPage = parser.parseFromString(data.products, 'text/html');
                const newProducts = productsPage.querySelector('.js-product-list');
                const oldProducts = this.$refs.rendered_products;
                this.$refs.rendered_products.parentNode?.replaceChild(newProducts, oldProducts);
                const newBottom = productsPage.querySelector('.js-products-bottom');
                const oldBottom = this.$refs
                    .rendered_products_bottom;
                this.$refs.rendered_products_bottom.parentNode?.replaceChild(newBottom, oldBottom);
                // @fractodo counter products - prendre en compte les blocs push
                const counters = document.querySelectorAll('.js-facet-products-count');
                const productsCount = document.querySelector('.js-products-bottom-total');
                counters.forEach((button) => {
                    button.innerHTML = productsCount
                        ? '(' + productsCount.dataset.value + ')'
                        : '(0)';
                });
                this.$refs.rendered_products_count.innerHTML = productsCount
                    ? productsCount.dataset.value
                    : '0';
                const facetsWrapper = document.querySelector('.js-facets-items-wrapper');
                if (facetsWrapper && data.facets) {
                    document.body.classList.remove('overflow-y-hidden');
                    facetsWrapper.innerHTML = data.facets;
                    this.checkFacets(null);
                    requestAnimationFrame(() => this.checkFacetsOverflow());
                }
                this.isLoading = false;
                toggleBodyOverflow(this.isLoading);
                const top = this.$refs.rendered_facets.offsetTop - 100;
                window.scrollTo({ top, behavior: 'smooth' });
            });
        }
    },
    appendProductListDom(url) {
        if (this.$refs.rendered_products) {
            this.getProductList(url).then((data) => {
                const parser = new DOMParser();
                const page = parser.parseFromString(data.products, 'text/html');
                const products = page.querySelectorAll('.js-product-list > div');
                const lastChild = this.$refs.rendered_products
                    .lastElementChild;
                products.forEach((item) => {
                    this.$refs.rendered_products.appendChild(item);
                });
                window.scrollTo({
                    top: lastChild.offsetTop - 200,
                    behavior: 'smooth',
                });
                this.counter += products.length;
                this.$refs.next.remove();
                if (page.querySelector('.js-next-page')) {
                    this.$refs.rendered_products_bottom.appendChild(page.querySelector('.js-next-page'));
                }
                this.isLoading = false;
                toggleBodyOverflow(this.isLoading);
            });
        }
        else {
            this.isLoading = false;
            toggleBodyOverflow(this.isLoading);
        }
    },
    async getProductList(url) {
        this.controller.abort();
        this.controller = new AbortController();
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'X-Header-Name': 'category',
            },
            signal: this.controller.signal,
        });
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        return response.json();
    },
    nextPage(url) {
        this.isLoading = true;
        this.currentQuery = EQUERY_TYPES.NEXT_PAGE;
        toggleBodyOverflow(this.isLoading);
        this.appendProductListDom(url);
    },
    init() {
        this.handleScrollEvent();
        window.addEventListener('scroll', throttle(this.handleScrollEvent.bind(this), 150), { passive: true });
        this.checkFacets(null);
        requestAnimationFrame(() => this.checkFacetsOverflow());
        // Le ResizeObserver recalcule le débordement des facets pour cacher les facets en overflow et placer le btn "voir plus"
        const el = this.$refs.facets_scroll;
        if (el && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(() => {
                if (this.facetsAdjusting)
                    return;
                this.checkFacetsOverflow();
            });
            observer.observe(el);
        }
        else {
            window.addEventListener('resize', throttle(() => this.checkFacetsOverflow(), 200), { passive: true });
        }
    },
}));
const Facets = { FacetsItems, Price };
export { Facets };
